// src/components/blog/BlogList.jsx
import React from "react";
import { Container, Heading, SimpleGrid } from "@chakra-ui/react";
import BlogCard from "./BlogCard";
import { caseStudies } from "../../../data/caseStudies";

export default function BlogList() {
  return (
    <Container maxW="6xl" py={{ base: 8, md: 12 }}>
      <Heading size="lg" mb={6}>
        Case Studies & Guides
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {caseStudies.map((cs) => (
          <BlogCard key={cs.slug} item={cs} />
        ))}
      </SimpleGrid>
    </Container>
  );
}
